import { isTokenExpired } from "../../../utils/persist";

export class TokenValidationCommand {
  constructor(token) {
    this.token = token;
  }

  execute() {
    return !!this.token && !isTokenExpired(this.token);
  }
}
